<template>
  <div
    class="mt-[66px] mb-[180px]"
    :class="{
      '!mb-[100px]': type === DELETE_TYPE.TEAM,
    }"
  >
    <div class="text-font-80 text-center">
      {{
        $t(
          'wo-men-xu-yao-dui-nin-de-shen-fen-jin-hang-xiao-yan-yi-que-bao-nin-shi-zhang-hao-suo-you-zhe-ben-ren'
        )
      }}
    </div>
    <a-form
      ref="formRef"
      :model="formState"
      hide-required-mark
      v-bind="formLayout"
      class="w-[390px] mx-auto my-[40px]"
    >
      <a-form-item
        v-if="!isGlobalVersion()"
        name="mobile"
        :label="$t('shou-ji-hao')"
        :rules="[{ required: true, message: $t('qing-shu-ru-shou-ji-hao') }]"
      >
        <a-input
          v-model:value="formState.mobile"
          :disabled="true"
          size="large"
          :placeholder="$t('qing-shu-ru-shou-ji-hao')"
        />
      </a-form-item>
      <a-form-item
        v-else
        name="email"
        :label="$t('you-xiang')"
        :rules="[{ required: true, message: $t('qing-shu-ru-you-xiang') }]"
      >
        <a-input
          v-model:value="formState.email"
          :disabled="true"
          size="large"
          :placeholder="$t('qing-shu-ru-you-xiang')"
        />
      </a-form-item>
      <a-form-item
        :label="
          !isGlobalVersion()
            ? $t('shou-ji-yan-zheng-ma')
            : $t('you-xiang-yan-zheng-ma')
        "
        name="sms_code"
        :rules="[
          { required: true, message: $t('qing-shu-ru-yan-zheng-ma') },
          {
            pattern: smsCodeReg,
            message: $t('6-wei-shu-zi-yan-zheng-ma'),
            trigger: 'blur',
          },
        ]"
      >
        <XCaptchaInput
          v-model:value="formState.sms_code"
          size="large"
          :placeholder="$t('qing-shu-ru-yan-zheng-ma')"
          :data="data"
        />
      </a-form-item>
    </a-form>
  </div>
  <div class="delete-modal-footer">
    <a-button type="primary" ghost @click="onSubmit">
      {{ $t('ji-xu-zhu-xiao') }}
    </a-button>
    <a-button type="primary" @click="emits('cancel')">
      {{ $t('zan-bu-zhu-xiao') }}
    </a-button>
  </div>
</template>

<script lang="ts" setup>
import type { FormInstance } from 'ant-design-vue'
import { smsCodeReg } from '@/utils/form'
import { checkDeleteCode } from '@/api'
import { VERIFY_RESULT } from '~/utils/track'
import { DELETE_TYPE } from '~/utils/constant'

interface FormType {
  mobile: string
  sms_code: string
  email: string
}

const props = defineProps<{
  data: string
  type: DELETE_TYPE
}>()
const emits = defineEmits(['cancel', 'set'])

const formLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
}
const formRef = ref<FormInstance>()
const formState = reactive<FormType>({
  mobile: props.data,
  sms_code: '',
  email: props.data,
})

watch(
  () => props.data,
  (cur) => {
    if (cur) {
      if (isGlobalVersion()) {
        formState.email = cur
      } else {
        formState.mobile = cur
      }
    }
  },
  { immediate: true }
)

const onSubmit = async () => {
  const res: any = await formRef.value?.validateFields()

  try {
    const result = await checkDeleteCode(res)

    if (!result.code) {
      trackEvent(TRACK_EVENT.LOG_OFF_ACCOUNT_VERIFY, {
        Mobile: res.mobile,
        SucVerification: VERIFY_RESULT.SUCCESS,
      })
      emits('set', 'submit', res.sms_code)
    }
  } catch (error) {
    console.error(error)

    trackEvent(TRACK_EVENT.LOG_OFF_ACCOUNT_VERIFY, {
      Mobile: res.mobile,
      SucVerification: VERIFY_RESULT.FAIL,
    })
  }
}
</script>
